import { __spreadArray } from 'tslib';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-date-range-grid.css';

var getClassNameList = classNames.bind(styles);
var UitkDateRangeGridGetCenterScrollDistance = function (selectedDateOffset, selectedDateWidth, dateRangeWidth) {
    return selectedDateOffset + selectedDateWidth / 2 - dateRangeWidth / 2 > 0
        ? selectedDateOffset + selectedDateWidth / 2 - dateRangeWidth / 2
        : 0;
};
var UitkDateRangeGridGetSelectedHeaderIndex = function (headersRowArray) {
    return __spreadArray([], Array(headersRowArray)[0], true).findIndex(function (th) {
        return th.classList.contains(getClassNameList('selected-header'));
    });
};
var UitkDateRangeGridGetSelectedDateScrollCenterDistance = function (dateRangeGrid) {
    var _a;
    if (!dateRangeGrid) {
        return 0;
    }
    var columnHeaders = (_a = dateRangeGrid === null || dateRangeGrid === void 0 ? void 0 : dateRangeGrid.firstElementChild) === null || _a === void 0 ? void 0 : _a.querySelectorAll('tr')[1].querySelectorAll('th');
    var selectedColumnIndex = UitkDateRangeGridGetSelectedHeaderIndex(columnHeaders);
    var selectedHeaderEl = columnHeaders[selectedColumnIndex];
    var dateRangeGridWidth = dateRangeGrid === null || dateRangeGrid === void 0 ? void 0 : dateRangeGrid.offsetWidth;
    var rowHeaderWidth = columnHeaders[columnHeaders.length - 1].offsetWidth;
    var tableContentsWidth = dateRangeGridWidth - rowHeaderWidth;
    var selectedDatePxWidth = selectedHeaderEl && selectedHeaderEl.offsetWidth;
    var selectedDatePxOffset = selectedHeaderEl && selectedHeaderEl.offsetLeft;
    return UitkDateRangeGridGetCenterScrollDistance(selectedDatePxOffset, selectedDatePxWidth, tableContentsWidth);
};

export { UitkDateRangeGridGetSelectedDateScrollCenterDistance };
